import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import PlaygroundApp from "@/pages/playground/App";

export const Route = createFileRoute("/dashboard/playground/")({
  component: PlaygroundPage,
});

function PlaygroundPage() {
  return (
    <ProtectedRoute>
      <div className="h-full w-full">
        <PlaygroundApp />
      </div>
    </ProtectedRoute>
  );
}
